import { Link, useNavigate } from "react-router-dom";
import {
  GraduationCap,
  BookOpen,
  ClipboardCheck,
  ArrowRight,
  ArrowLeft
} from "lucide-react";

const ChooseExamPageFree = () => {
  const navigate = useNavigate();

  const exams = [
    {
      id: "jamb",
      title: "JAMB",
      description: "Joint Admissions and Matriculation Board",
      icon: BookOpen,
      path: "/take-promotional-free/JAMB",
      color: "from-purple-500 to-purple-600"
    },
    {
      id: "waec",
      title: "WAEC",
      description: "West African Examinations Council",
      icon: GraduationCap,
      path: "/take-promotional-free/WAEC",
      color: "from-blue-500 to-blue-600"
    },
    {
      id: "exam",
      title: "General Exam",
      description: "Practice tests and assessments",
      icon: ClipboardCheck,
      path: "/free-take/exam",
      color: "from-emerald-500 to-emerald-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-6">
      <div className="w-full max-w-4xl">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-800 mb-8 transition-colors group"
        >
          <ArrowLeft
            size={20}
            className="transform group-hover:-translate-x-1 transition-transform"
          />
          <span className="font-medium">Back</span>
        </button>

        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Choose Your Exam
          </h1>
          <p className="text-slate-600 text-lg">
            Select an exam type to begin your preparation journey
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {exams.map((exam) => {
            const Icon = exam.icon;
            return (
              <Link
                key={exam.id}
                to={exam.path}
                className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${exam.color} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-300`}
                />

                <div className="relative">
                  <div
                    className={`inline-flex p-4 rounded-xl bg-gradient-to-br ${exam.color} mb-4 transform group-hover:scale-110 transition-transform duration-300`}
                  >
                    <Icon className="text-white" size={32} />
                  </div>

                  <h3 className="text-2xl font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors">
                    {exam.title}
                  </h3>

                  <p className="text-slate-600 mb-6 min-h-[3rem]">
                    {exam.description}
                  </p>

                  <div className="flex items-center text-blue-600 font-semibold group-hover:gap-2 transition-all">
                    <span>Start Exam</span>
                    <ArrowRight
                      size={20}
                      className="transform group-hover:translate-x-1 transition-transform"
                    />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-slate-500 text-sm">
            Need help? Contact support for assistance with your exam preparation
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChooseExamPageFree;
